import { render, staticRenderFns } from "./btn-text-quarternary3.vue?vue&type=template&id=4c3b2c1a&scoped=true&"
import script from "./btn-text-quarternary3.vue?vue&type=script&lang=js&"
export * from "./btn-text-quarternary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b2c1a",
  null
  
)

export default component.exports